import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import hero1 from "../../assets/img/hero1.jpg";
import hero2 from "../../assets/img/hero2.jpg";
import hero3 from "../../assets/img/hero3.jpg";

function Hero() {
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  const slides = [
    {
      image: hero1,
      text: "An efficient, modern and commercially-oriented irrigation sector.",
    },
    {
      image: hero2,
      text: "Empowering farmers through sustainable water management.",
    },
    {
      image: hero3,
      text: "Innovative solutions for a thriving agricultural future.",
    },
  ];

  return (
    <div className="w-full relative lg:mt-[12.4rem] mt-[10rem] h-[600px]">
      <Swiper
        modules={[Autoplay, Navigation]}
        autoplay={{ delay: 6500, disableOnInteraction: false }}
        loop
        navigation={{ prevEl, nextEl }}
        className="h-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="h-full flex items-center justify-center text-white lg:text-[2.25rem] text-[1.75rem] font-[400] font-sora"
              style={{
                backgroundImage: `url(${slide?.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <span className="lg:w-[46.875rem] w-full flex items-center justify-center text-center p-4">
                {slide?.text}
              </span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
 
      <button
        ref={(node) => setPrevEl(node)}
        className="absolute top-1/2 -translate-y-1/2 left-4 z-10 cursor-pointer  flex items-center justify-center w-[2.8125rem] h-[2.8125rem] rounded-[1.6875rem] border-[#D6E1F5] bg-white/40"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="14"
          viewBox="0 0 7 14"
          fill="none"
        >
          <path
            d="M0.0905515 6.99081C0.0905514 6.84081 0.140551 6.71581 0.240551 6.59081L5.89055 0.840808C6.11555 0.615808 6.46555 0.615808 6.69055 0.840808C6.91555 1.06581 6.91555 1.41581 6.69055 1.64081L1.46555 6.99081L6.74055 12.3408C6.96555 12.5658 6.96555 12.9158 6.74055 13.1408C6.51555 13.3658 6.16555 13.3658 5.94055 13.1408L0.290551 7.39081C0.165551 7.26581 0.0905515 7.14081 0.0905515 6.99081Z"
            fill="#050505"
          />
        </svg>
      </button>
      <button
        ref={(node) => setNextEl(node)}
        className="absolute top-1/2 -translate-y-1/2 right-4 z-10 cursor-pointer flex items-center justify-center  w-[2.8125rem] h-[2.8125rem] rounded-[1.6875rem] border-[#D6E1F5] bg-white/40"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="14"
          viewBox="0 0 7 14"
          fill="none"
        >
          <path
            d="M6.90933 6.9907C6.90933 7.1407 6.85933 7.2657 6.75933 7.3907L1.10933 13.1407C0.884326 13.3657 0.534326 13.3657 0.309326 13.1407C0.0843263 12.9157 0.0843263 12.5657 0.309326 12.3407L5.53433 6.9907L0.259326 1.6407C0.0343256 1.4157 0.0343256 1.0657 0.259326 0.840698C0.484326 0.615698 0.834326 0.615698 1.05933 0.840698L6.70933 6.5907C6.83433 6.7157 6.90933 6.8407 6.90933 6.9907Z"
            fill="#050505"
          />
        </svg>
      </button>
    </div>
  );
}

export default Hero;
